module.exports = __webpack_public_path__ + "img/align-right.70c73bd5.svg";